const initialState = {
    userLogged: null,
};
  
  const userReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'LOGIN_USER':
        return {
          ...state,
          userLogged: action.payload,
        };
  
      // Otros casos para otras acciones
      default:
        return state;
    }
  };
  
  export default userReducer;